import { alpha, useTheme } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import is from '@sindresorhus/is';
import { Link } from 'react-router';

import { Shade } from '../../../app/theming';
import { InlineBadge } from '../badges/InlineBadge';

import type { TabProps } from '@mui/material/Tab';
import type { FunctionComponent } from 'react';

type TabWithBadgeProps = {
    readonly badgeLabel?: string | undefined;
    readonly label: string;
    readonly replace?: boolean;
    readonly to: URLSearchParams;
    readonly value?: number | string;
};

export const TabWithBadge: FunctionComponent<TabWithBadgeProps> = (props) => {
    const { badgeLabel, label, replace = true, to, value, ...muiOverrideProps } = props;
    const theme = useTheme();
    const badgeBackgroundColor = alpha(theme.palette.secondary.main, Shade.p8);

    const iconPosition: TabProps['iconPosition'] = 'end';
    const iconProp = is.string(badgeLabel)
        ? {
              icon: (
                  <InlineBadge
                      backgroundColor={badgeBackgroundColor}
                      label={badgeLabel}
                      textColor={theme.palette.text.primary}
                  />
              ),
              iconPosition,
          }
        : {};

    return (
        <Tab
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...muiOverrideProps}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...iconProp}
            component={Link}
            label={label}
            replace={replace}
            sx={{
                ['&.Mui-selected']: { color: 'text.primary' },
                color: 'text.secondary',
                columnGap: 1,
                lineHeight: '4em',
                minHeight: 'revert',
                px: 1,
                py: 0,
            }}
            to={{ pathname: '', search: to.toString() }}
            value={value}
        />
    );
};
